import React from 'react';
import './FindingDetails.css';

function DeveloperFindingDetails({ finding }) {
  if (!finding) return null;

  return (
    <div className="finding-details developer-finding-details">
      {finding.file_path && (
        <div className="finding-details-item">
          <span className="finding-details-label">Location</span>
          <div className="finding-location">
            <code>{finding.file_path}{finding.line_number ? `:${finding.line_number}` : ''}</code>
          </div>
        </div>
      )}

      {finding.code_snippet && (
        <div className="finding-details-item">
          <span className="finding-details-label">Evidence</span>
          <pre className="code-snippet">
            <code>{finding.code_snippet}</code>
          </pre>
        </div>
      )}

      <div className="finding-details-item">
        <span className="finding-details-label">Technical Summary</span>
        <p>{finding.description || finding.summary || 'No technical summary provided.'}</p>
      </div>
      <div className="finding-details-item">
        <span className="finding-details-label">Recommendation</span>
        <p>{finding.recommendation || 'Review remediation guidance in the full report.'}</p>
      </div>
      {finding.references && (
        <div className="finding-details-item">
          <span className="finding-details-label">References</span>
          <p>{finding.references}</p>
        </div>
      )}
    </div>
  );
}

export default DeveloperFindingDetails;
